'use strict';

angular.module('sellersService')
.factory('sqs', [ '$rootScope', '$q', '$log' , function ($rootScope, $q, $log) {

    // Create an instance of our SQS Client.
    var sqs = new AWS.SQS({
        region: "ap-southeast-2"
        ,accessKeyId: "AKIAJNOQ4ZCBFYD2HLWA"
        ,secretAccessKey: "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"
        ,params: {
            QueueUrl: "https://sqs.ap-southeast-2.amazonaws.com/693753024782/wiseberry-livefeed-201605"
        }
    });

    var service = {};

    service.receiveMessage = function(params){
        var dfd = $q.defer();
        
        sqs.receiveMessage(params, function(err, data) {
             if (err) dfd.reject("Error: request returned status " + err.stack);
              else    dfd.resolve(data);           
        });

        return dfd.promise;
    }

    service.deleteMessage = function(params){
        var dfd = $q.defer();
        
        sqs.deleteMessage(params, function(err, data) {
             if (err) dfd.reject("Error: request returned status " + err.stack);
              else    dfd.resolve(data);           
        });

        return dfd.promise;
    }

    service.pollQueueForMessages = function() {
        var dfd = $q.defer();
        
        service.receiveMessage({
            WaitTimeSeconds: 20 // Enable long-polling.
            , VisibilityTimeout: 10
            , MaxNumberOfMessages: 5
        }).then(
            function handleMessageResolve(data) {
                if (!data.Messages){
                    throw(
                        error(
                            "EmptyQueue", 
                            new Error("There are no messages to process.")
                        )
                    );
                } else {
                    // Return messages
                    dfd.resolve(data);    
                }            
            }
        )
        // Catch any error (or rejection) that took place during processing.
        .catch(
            function handleError( error ) {
                switch ( error.type ) {
                    case "EmptyQueue":
                        $log.info("Expected Error: "+ error.message );
                    break;
                    default:
                        $log.info("Unexpected Error: "+ error.message);
                    break;
                }

            }
        );

        return dfd.promise;
    }

    return service;

  }
]);